module.exports = __webpack_public_path__ + "img/25.1457adf4.png";